// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".addon-text[data-v-8be6e9ca]{font-size:12px;text-transform:uppercase}.rdt-container[data-v-8be6e9ca]{height:60vh}@media only screen and (max-width:768px){.rdt-container[data-v-8be6e9ca]{height:50vh}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
